module.exports = __webpack_public_path__ + "static/img/home_story.f416e0df.png";